import React from 'react';
import logoJPG from '../../assets/images/header/header.jpg';
import logoJXR from '../../assets/images/header/header.jxr';
import logoWEBP from '../../assets/images/header/header.webp';
import logoJP2 from '../../assets/images/header/header.jp2';

function HeaderImage() {

    const imageStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative", 
      width: "auto",
      textAlign: "center",
      marginTop: 117
    };

    const txtBlockStyle = {
      position: "absolute",
      color: "white",
      fontWeight: "bold",
      fontSize: '4vw',
      top: '6vw',
      left: '3vw',
      width: "fit-content",
      height: "fit-content"
    };
  
    return (
      <div className="mobMargin" style={imageStyle}>
        <div className="text" style={txtBlockStyle}>
          Campus Webcams
        </div>
        <img loading="lazy" style={{flex:1}} alt={''} src={logoJPG}/>
      </div>
    );
}

export default HeaderImage;